import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
import useModalQueryParam from 'hooks/useModalQueryParam';
import { useUpdateAssets } from 'actions/assets';
import assetKeys from 'actions/assets/queryKeys';
import { playlistQueryKeys } from 'actions/playlists';
import { formatAssetEditorPayloadForApi } from 'screens/AssetEditor';
import AssetManager from 'screens/AssetManager';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function Edit(_ref) {
  var Component = _ref.as,
    asset = _ref.asset,
    parentPlaylistId = _ref.parentPlaylistId,
    parentPlaylist = _ref.parentPlaylist;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var queryClient = useQueryClient();
  var _useModalQueryParam = useModalQueryParam("edit-asset-".concat(asset.id)),
    _useModalQueryParam2 = _slicedToArray(_useModalQueryParam, 2),
    hasAssetEditor = _useModalQueryParam2[0],
    toggleAssetEditor = _useModalQueryParam2[1];
  var _useUpdateAssets = useUpdateAssets({
      assetIds: [asset.id],
      parentPlaylistIds: parentPlaylistId,
      hasSuccessAlert: true
    }),
    updateAssets = _useUpdateAssets.updateAssets;
  function submitAssetEditor(_x) {
    return _submitAssetEditor.apply(this, arguments);
  }
  function _submitAssetEditor() {
    _submitAssetEditor = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var changes, formattedData;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            changes = _ref2.changes;
            formattedData = formatAssetEditorPayloadForApi({
              changes: changes,
              parentPlaylistId: parentPlaylistId
            });
            _context.next = 1;
            return updateAssets(formattedData);
          case 1:
            queryClient.invalidateQueries({
              queryKey: assetKeys.assets
            });
            queryClient.invalidateQueries({
              queryKey: playlistQueryKeys.allPlaylists
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _submitAssetEditor.apply(this, arguments);
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Component, {
      icon: "edit",
      onClick: toggleAssetEditor,
      children: t('actions_edit')
    }), hasAssetEditor && /*#__PURE__*/_jsx(AssetManager, {
      inContentManagerContext: false,
      hasOpenOption: false,
      assets: [asset],
      parentPlaylist: parentPlaylist,
      onClose: toggleAssetEditor,
      onSubmit: submitAssetEditor
    })]
  });
}
export default Edit;